/*
  Kollektionsseite: ausverkaufte Farben aus den Kartenpunkten und aus den
  Filter-Chips nehmen.

  Warum ueberhaupt JavaScript und kein CSS wie auf der Produktseite:
  Die Farbpunkte (.ph-dot / .cdot) tragen nur ein data-img, die Chips (.achip)
  nur den Farbnamen. Die Verfuegbarkeit steht im Markup NICHT drin. Ein
  CSS-Selektor koennte die Farben also nur an ihrem Namen erkennen, und ein fest
  verdrahteter Name wuerde beim Restock nicht von selbst verschwinden. Deshalb
  wird der echte Bestand einmal je Seitenaufruf geholt.

  Warum nicht in eyg-collection-main.liquid: die Section ist 46 KB gross und
  wird beim Schreiben immer komplett ersetzt. Gleiche Begruendung wie bei
  assets/eyg-pdp-fix.css.

  Quelle der Wahrheit: /collections/<handle>/products.json. Ein Aufruf liefert
  alle Produkte der Kollektion samt Varianten und deren available-Flag.

  Zuordnung Punkt zu Farbe laeuft ueber die POSITION: die Section rendert einen
  Punkt je Wert der ersten Option, in derselben Reihenfolge. Stimmt die Anzahl
  einmal nicht ueberein, wird die Karte in Ruhe gelassen, statt den falschen
  Punkt zu verstecken.

  Faellt der Abruf aus, passiert nichts. Lieber alle Farben zeigen als aus
  Versehen lieferbare ausblenden.

  Rueckgaengig: diese Datei und die eine Zeile in layout/theme.liquid entfernen.
  Beim Restock ist nichts zu tun, available springt von selbst zurueck.
*/
(function () {
  'use strict';

  function start() {
    var scope = document.querySelector('.eyg-colx');
    if (!scope) return;

    var match = location.pathname.match(/\/collections\/[^/?#]+/);
    if (!match) return;

    /* Sprachpraefix (/en) mitnehmen, sonst kommen deutsche Optionswerte zurueck. */
    var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    fetch(root + match[0] + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) { wire(scope, data.products || []); })
      .catch(function () { /* im Zweifel nichts verstecken */ });
  }

  function wire(scope, products) {
    var byHandle = {};
    var alleFarben = {};
    var irgendwoLieferbar = {};

    products.forEach(function (p) {
      var opt = (p.options || [])[0];
      if (!opt) return;
      var werte = opt.values || [];
      var ok = {};
      (p.variants || []).forEach(function (v) {
        if (v.available) ok[v.option1] = true;
      });
      byHandle[p.handle] = { werte: werte, ok: ok };
      werte.forEach(function (w) { alleFarben[w] = true; });
      Object.keys(ok).forEach(function (w) { irgendwoLieferbar[w] = true; });
    });

    function anwenden() {
      // 1) Farbpunkte auf den Produktkarten
      scope.querySelectorAll('.pcard').forEach(function (card) {
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        var handle = (link.getAttribute('href') || '').split('/products/')[1];
        if (!handle) return;
        handle = handle.split(/[?#/]/)[0];
        var info = byHandle[handle];
        if (!info) return;

        card.querySelectorAll('.ph-dots, .color-dots').forEach(function (gruppe) {
          var punkte = Array.prototype.slice.call(gruppe.children);
          if (punkte.length !== info.werte.length) return;  // Zuordnung unsicher
          punkte.forEach(function (punkt, i) {
            if (punkt.classList.contains('active')) return;  // aktive Ansicht nie verstecken
            punkt.hidden = !info.ok[info.werte[i]];
          });
        });
      });

      // 2) Filter-Chips: nur weg, wenn die Farbe in der ganzen Kollektion fehlt
      scope.querySelectorAll('.achip').forEach(function (chip) {
        var label = (chip.textContent || '').trim();
        if (!alleFarben[label]) return;                    // kein Farb-Chip
        chip.hidden = !irgendwoLieferbar[label];
      });
    }

    anwenden();

    // Sortieren und Filtern zeichnet das Raster neu, dann erneut anwenden.
    var grid = scope.querySelector('.pcard') && scope.querySelector('.pcard').parentNode;
    if (grid && window.MutationObserver) {
      var warten = null;
      new MutationObserver(function () {
        clearTimeout(warten);
        warten = setTimeout(anwenden, 60);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
